import { IconProps } from "@utils/types/components";

export const ListeningIcon = ({
  width,
  height,
  color = "currentcolor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.326 18.485H3.143a2.17 2.17 0 01-1.542-.603c-.427-.402-.641-.886-.641-1.45v-7.19c0-1.283.26-2.485.778-3.606a9.388 9.388 0 012.1-2.927c.883-.83 1.92-1.49 3.111-1.977A10.018 10.018 0 0110.783 0c1.364 0 2.642.244 3.833.732a10.038 10.038 0 013.11 1.977 9.387 9.387 0 012.101 2.927 8.49 8.49 0 01.778 3.607v7.189c0 .564-.214 1.048-.641 1.45a2.17 2.17 0 01-1.542.603H16.24a2.17 2.17 0 01-1.541-.603c-.428-.402-.641-.886-.641-1.45v-4.108c0-.565.213-1.049.64-1.45a2.17 2.17 0 011.543-.604h2.182V9.243c0-2.003-.741-3.702-2.224-5.097-1.482-1.395-3.287-2.092-5.415-2.092-2.129 0-3.934.697-5.417 2.092C3.884 5.541 3.143 7.24 3.143 9.243v1.027h2.183c.6 0 1.114.2 1.541.603.428.402.641.886.641 1.45v4.109c0 .564-.213 1.048-.64 1.45a2.17 2.17 0 01-1.542.603zm0-6.161H3.143v4.108h2.183v-4.108zm10.913 0v4.108h2.183v-4.108H16.24z"
        fill={color}
      />
    </svg>
  );
};
